import { Component, OnInit, ViewChild } from '@angular/core';
import {
  UserExtraInfoModel,
  UserModel,
  UsersService,
} from '../users/users.service';
import { BaseService } from '../../../base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '../../../toast.service';
import { freeSet } from '@coreui/icons';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-clientpage',
  templateUrl: './clientpage.component.html',
  styleUrls: ['./clientpage.component.scss'],
})
export class ClientpageComponent implements OnInit {
  constructor(
    public UsersService: UsersService,
    public BaseService: BaseService,
    public router: Router,
    private route: ActivatedRoute,
    public ToastService: ToastService
  ) {}
  icons = freeSet;

  PreviousPassowrd: any;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
  msg: any;
  ModalVisible: boolean = false;
  ModalVisibleLicenseDetails: boolean = false;
  customStylesValidated: boolean = false;
  Loading: boolean = false;
  ButtonLoading: boolean = false;
  EditMode: boolean = false;
  @ViewChild('imageField') imageField: any;

  toggleModal() {
    if (this.ModalVisible) {
      this.customStylesValidated = false;
      this.UsersService.UserData = new UserModel();
      this.EditMode = false;
      this.imageSrc = undefined;
      this.fileSelected = undefined;
      this.imageField.nativeElement.value = '';
    }
    this.ModalVisible = !this.ModalVisible;
  }
  generatePassword(): void {
    this.UsersService.UserData.password =
      this.UsersService.generateRandomPassword(12);
    this.confirmPassword = this.UsersService.UserData.password;
  }
  toggleModalLicenseDetails() {
    if (this.ModalVisibleLicenseDetails) {
      this.customStylesValidated = false;
      this.UsersService.UserData = new UserModel();
      this.EditMode = false;
      this.imageSrc = undefined;
      this.fileSelected = undefined;
      this.imageField.nativeElement.value = '';
    }
    this.ModalVisibleLicenseDetails = !this.ModalVisibleLicenseDetails;
  }
  details_visible = Object.create({});
  toggleDetails(item: any) {
    this.details_visible[item] = !this.details_visible[item];
  }

  LicensesData: any;

  LicensesColumns: any = [
    {
      key: 'productName',
      label: 'Product Name',
    },
    {
      key: 'date_Start',
      label: 'Date Created',
    },
    {
      key: 'date_Expire',
      label: 'Expiry Date',
    },
    {
      key: 'isActive',
      label: 'Status',
    },
    // {
    //   key: 'Actions',
    //   label: '',
    //   _style: { width: '5%' },
    //   filter: false,
    //   sorter: false,
    // },
  ];

  UserData: any;
  IsAdmin: boolean = false;
  ActiveTab: any;
  userInfo: any;
  ngOnInit(): void {
    //is admin login?
    const key = this.route.snapshot.queryParamMap.get('key');
    this.ActiveTab = key;
    console.log('Query param key:', key);
    this.userInfo = JSON.parse(localStorage.getItem('UserInfo') || '{}');
    if (this.userInfo.userType_Id == 3) {
      this.IsAdmin = true;
    }
    this.UsersService.selectedClientData.subscribe((data) => {
      this.UserData = data;
    });
    this.getLicenses(this.UserData.id);
    this.getUserExtraInfo();
  }
  CheckTabAccessiblity(Parent: any, tabName: any) {
    // let menuListString = localStorage.getItem('menuData') as string;
    // let menuList = JSON.parse(menuListString);

    // console.log("🚀 > CheckTabAccessiblity > JSON.parse(menuListString):", JSON.parse(menuListString))

    // let ParentMenuId = menuList?.find(
    //   (item: any) => item.url == Parent && item.isActive == true
    // ).id;
    // let TabMenus = menuList?.filter(
    //   (item: any) => item.parent_Id == ParentMenuId && item.isActive == true
    // );
    // if (
    //   TabMenus?.filter(
    //     (item: any) => item.url == tabName && item.isActive == true
    //   ).length > 0
    // ) {
    //   return true;
    // } else {
    //   return false;
    // }
    return true;
  }

  LicensesDataToShow: any;
  licenseData: any;
  getLicenses(id: any) {
    this.Loading = true;
    var body = {
      id: id,
      type: 'U',
    };
    console.log('🚀 > getLicenses > body:', body);

    this.UsersService.getAllLicensesByPersonID(body).subscribe({
      next: (res: any) => {
        console.log(
          '🚀 > this.UsersService.getAllLicensesByPersonID > res:',
          res
        );

        this.LicensesData = res.data;
        // this.LicensesDataToShow = this.LicensesData?.map((item: any) => {
        //   return {
        //     ...item,
        //     productName: item.license_Products[0].productName,
        //     date_Expire: item.license_Products[0].date_Expire,
        //     date_Start: item.license_Products[0].date_Start,
        //     isActive: item.license_Products[0].isActive,
        //     // extraNoOfStores: item.license_Products[0].extraNoOfStores,
        //     // isRMHCentral: item.licenseDetails[0].isRMHCentral,
        //   };
        // });
        this.LicensesDataToShow = res.data[0]?.license_Products;

        console.log(this.LicensesDataToShow);
        this.Loading = false;
      },
      error: (error) => {
        console.error(error);
        this.Loading = false;
      },
    });
  }

  ShowLicenseDetails(item: any) {
    console.log(this.LicensesDataToShow);
    console.log('🚀 > ClientpageComponent > ShowLicenseDetails > item:', item);
    this.licenseData = item;
    this.toggleModalLicenseDetails();
  }

  fileSelected: File | undefined;
  imageSrc: string | ArrayBuffer | undefined;
  onFileSelected(event: any) {
    console.log(event.target.files[0]);
    const maxAllowedSize = 2 * 1024 * 1024;
    if (event.target.files[0].size > maxAllowedSize) {
      alert('Only 2 MB size is allowed!');
      event.target.value = '';
    }
    const file: File = event.target.files[0];
    this.fileSelected = file;
    this.UsersService.UserData.file = file;
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(file);
    }
    console.log(
      '🚀 > PromotionsComponent > onFileSelected > this.fileSelected:',
      this.fileSelected
    );
  }

  EditUser(data: any) {
    this.UsersService.UserData = data;
    this.toggleModal();
    this.EditMode = true;
  }

  ModalVisibleResetPassword: boolean = false;
  toggleModalResetPassword() {
    if (this.ModalVisibleResetPassword) {
      this.customStylesValidated = false;
      this.UsersService.UserData = new UserModel();
      this.EditMode = false;
    }
    this.ModalVisibleResetPassword = !this.ModalVisibleResetPassword;
  }
  confirmPassword: any;
  ResetPasswordModal(data: any) {
    this.UsersService.UserData = data;
    this.toggleModalResetPassword();
  }

  validatePhoneNumberInput(event: KeyboardEvent): void {
    const allowedChars = /[0-9\s()+-]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!allowedChars.test(inputChar)) {
      event.preventDefault();
    }
  }

  UpdateUserDetails(
    UsersDetailsForm: any,
    UserData: any,
    PasswordUpdate?: boolean
  ) {
    if (UsersDetailsForm.invalid) {
      this.customStylesValidated = true;
      return;
    }
    this.ButtonLoading = true;
    UserData.approvedFrom = JSON.parse(
      localStorage.getItem('UserInfo')?.toString() || '{}'
    )?.id;
    UserData.createdBy = JSON.parse(
      localStorage.getItem('UserInfo')?.toString() || '{}'
    )?.id;

    if (UserData.password == undefined || UserData.password == '') {
      UserData.password = '.';
    }

    console.log(
      '🚀 > UserpageComponent > UpdateUserDetails > UserData:',
      UserData
    );
    var formData = new FormData();
    var formDataOutput = '';
    Object.keys(UserData).forEach((key) => {
      if (UserData[key] != null) {
        formData.append(key, UserData[key]);
        formDataOutput += '\n' + key + ':' + UserData[key];
        console.log(key, UserData[key]);
      }
    });
    console.log(
      '🚀 > ProductsComponent > Object.keys > formDataOutput:',
      formDataOutput
    );

    this.UsersService.editUser(formData).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.isSuccess) {
          const options = {
            title: 'Success',
            delay: 3000,
            color: 'success',
            autohide: true,
            description: res.message,
            status: true,
          };
          this.ToastService.showToast(options);
          UserData.password = '';

          this.UsersService.selectedClientDataUpdate(UserData);
        } else {
          const options = {
            title: 'Failed',
            delay: 3000,
            color: 'danger',
            autohide: true,
            description: res.message,
            status: false,
          };
          this.ToastService.showToast(options);
        }
        this.ButtonLoading = false;
        if (PasswordUpdate) {
          this.toggleModalResetPassword();
        } else {
          this.toggleModal();
        }
        this.ngOnInit();
      },
      error: (error) => {
        console.error(error);
        alert('Error: ' + error.error.message);
      },
    });

    // this.router.navigate(['/partners']);
  }

  DeleteUser(item: any) {
    if (!confirm('Are you sure you want to delete this User?')) {
      return;
    }
    this.UsersService.deleteUser(item.id).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.isSuccess) {
          this.msg = res;
          setTimeout(() => {
            this.msg = undefined;
            const options = {
              title: 'Success',
              delay: 3000,
              color: 'success',
              autohide: true,
              description: res.message,
              status: true,
            };
            this.ToastService.showToast(options);
          }, 1000);
          this.router.navigate(['/clients']);
          // this.getProducts();
        } else {
          this.msg = res;
          this.msg = undefined;
          const options = {
            title: 'Failed',
            delay: 3000,
            color: 'danger',
            autohide: true,
            description: res.message,
            status: false,
          };
          this.ToastService.showToast(options);
        }
      },
      error: (error) => {
        console.error(error);
        alert('Error: ' + error.error.message);
      },
    });
  }

  getUserExtraInfo() {
    this.UsersService.getUserExtraInfo().subscribe({
      next: (res: any) => {
        if (res.data.find((x: any) => x.users_Id == this.UserData.id)) {
          this.UsersService.UserExtraInfoData = res.data.find(
            (x: any) => x.users_Id == this.UserData.id
          );
        } else {
          this.UsersService.UserExtraInfoData = new UserExtraInfoModel();
          this.UsersService.UserExtraInfoData.users_Id = this.UserData.id;
          this.IsAddExtraInfo = true;
        }

        console.log(
          '🚀 > ProfileComponent > this.UsersService.getUserExtraInfo >  this.UsersService.UserExtraInfoData:',
          this.UsersService.UserExtraInfoData
        );
        console.log('🚀 > UserpageComponent > getUserExtraInfo > res:', res);
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  IsAddExtraInfo: boolean = false;
  EditUserExtraInfo(UserExtraInfoForm: NgForm) {
    this.customStylesValidated = true;
    if (UserExtraInfoForm.invalid) {
      return;
    }
    this.ButtonLoading = true;

    console.log(
      '🚀 > UserpageComponent > EditUserExtraInfo > UserExtraInfoForm:',
      UserExtraInfoForm
    );
    if (this.IsAddExtraInfo) {
      this.UsersService.addUserExtraInfo(
        this.UsersService.UserExtraInfoData
      ).subscribe({
        next: (res: any) => {
          console.log(res);
          if (res.isSuccess) {
            const options = {
              title: `Success`,
              delay: 3000,
              color: 'success',
              autohide: true,
              description: 'Client profile has been updated successfully',
              status: true,
            };
            this.ToastService.showToast(options);
            this.ngOnInit();
          } else {
            const options = {
              title: `Error`,
              delay: 3000,
              color: 'danger',
              autohide: true,
              description: res.message,
              status: false,
            };
            this.ToastService.showToast(options);

            setTimeout(() => {
              this.msg = undefined;
            }, 3000);
          }
          this.customStylesValidated = false;
          this.ButtonLoading = false;
        },
        error: (error) => {
          console.error(error);
          alert('Error: ' + error.error.message);
        },
      });
    } else {
      this.UsersService.editUserExtraInfo(
        this.UsersService.UserExtraInfoData
      ).subscribe({
        next: (res: any) => {
          console.log(res);
          if (res.isSuccess) {
            const options = {
              title: `Success`,
              delay: 3000,
              color: 'success',
              autohide: true,
              description: 'Client profile has been updated successfully',
              status: true,
            };
            this.ToastService.showToast(options);
            this.ngOnInit();
          } else {
            const options = {
              title: `Error`,
              delay: 3000,
              color: 'danger',
              autohide: true,
              description: res.message,
              status: false,
            };
            this.ToastService.showToast(options);

            setTimeout(() => {
              this.msg = undefined;
            }, 3000);
          }
          this.customStylesValidated = false;
          this.ButtonLoading = false;
        },
        error: (error) => {
          console.error(error);
          alert('Error: ' + error.error.message);
        },
      });
    }
  }
}
